import { Stack, Typography, styled } from '@mui/material';
import getConfig from 'next/config';
import Image from 'next/image';
import { useEffect, useState } from 'react';

import { WidgetType } from '../../../types/widget';
import WidgetImagesProvider from '../../settings/widgets/provider/WidgetImagesProvider';
import { PublicRuntimeConfigType } from '../../types/publicRuntimeConfig';
import MobileDashboard from '../dashboard/MobileDashboard';
import { useLogo } from '../LogoProvider';
import { useSession } from '../session/SessionContext';

const InfoWrapper = styled('div')(({ theme: { spacing } }) => ({
	height: '100%',
	width: '100%',
	display: 'flex',
	flexDirection: 'column',
	justifyContent: 'center',
	alignItems: 'center',
	gap: spacing(2),
}));

type MobileHomepageProps = {
	widgetsWithKey?: {
		key: string;
		widget: WidgetType;
	}[];
	loading: boolean;
};

const MobileHomepage = ({ widgetsWithKey, loading }: MobileHomepageProps) => {
	const { customerFile: sessionCustomerFile } = useSession();
	const { publicRuntimeConfig } = getConfig() as PublicRuntimeConfigType;
	const { standaloneModule } = publicRuntimeConfig;

	const { logo } = useLogo();

	const [logoUrl, setLogoUrl] = useState<string>();

	useEffect(
		() =>
			setLogoUrl((prevValue) => {
				if (prevValue) URL.revokeObjectURL(prevValue);

				return logo && URL.createObjectURL(logo);
			}),
		[logo],
	);

	return (
		<>
			{!sessionCustomerFile && (
				<InfoWrapper>
					<Typography variant="h6">Aucun dossier</Typography>
				</InfoWrapper>
			)}

			{sessionCustomerFile && !standaloneModule ? (
				<WidgetImagesProvider>
					<Stack flex={1}>
						<Stack py={2} justifyContent="center" alignItems="center">
							{logoUrl && (
								<Image
									src={logoUrl}
									loader={({ src }) => src}
									alt="logo"
									width={250}
									height={78}
									objectFit="contain"
									unoptimized
								/>
							)}
						</Stack>

						<MobileDashboard widgetsWithKey={widgetsWithKey} loading={loading} />
					</Stack>
				</WidgetImagesProvider>
			) : null}
		</>
	);
};

export default MobileHomepage;
